import type { ButtonProps } from './types';
import React from 'react';
import { Styled } from './index.styles';

/**
 * @deprecated This component is based on Semantic UI and will be removed in future releases. Use the RectangularButton component instead.
 * @see RectangularButton
 */
export const Button: React.FC<ButtonProps> = ({
  testid,
  variant,
  active = false,
  onClick,
  disabled = false,
  ...props
}) => (
  <Styled.SemanticButton
    $variant={variant}
    $active={active}
    data-testid={testid}
    {...(!disabled && { onClick })}
    {...{ disabled, ...props }}
  />
);
